import classNames from 'classnames';
import { MainLabelType } from 'components/UIComponents/GroupMultiSelect/GroupMultiSelect.types';
import { optionsToMainLabel } from 'components/UIComponents/GroupMultiSelect/GroupMultiSelect.utils';
import { useMemo } from 'react';

const SHOW_SELECTED_MAX = 3;

export const ReviewersEditLabel: MainLabelType = (props) => {
  const { selected, className, placeholder, loading } = props;
  const placeholderText = useMemo(() => {
    if (loading) {
      return 'Loading...';
    }

    const count = selected.length;
    if (count <= 0) {
      return placeholder;
    }

    if (count > SHOW_SELECTED_MAX) {
      return `${count} values selected`;
    }

    const commaItems = optionsToMainLabel(selected, placeholder);
    return commaItems;
  }, [selected, placeholder, loading]);

  return (
    <span className={classNames(className, { 'gms-main-label--loading': loading })}>
      {placeholderText}
    </span>
  );
};
